module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/process/process-02-1520b01c0acb9ad2e22278fad587a4b9.svg";